import { render, staticRenderFns } from "./MessagesSection.vue?vue&type=template&id=30bfa025&scoped=true&"
import script from "./MessagesSection.vue?vue&type=script&lang=js&"
export * from "./MessagesSection.vue?vue&type=script&lang=js&"
import style0 from "./MessagesSection.vue?vue&type=style&index=0&id=30bfa025&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bfa025",
  null
  
)

export default component.exports